<template>
  <div class="form-container error" v-if="error">
    <h4>Oops! Something went wrong</h4>
    <p v-html="errorMessage"></p>
  </div>
  <div class="home" v-else>
    <div class="form-container" v-if="!isLoading">
      <h4>Success!</h4>
      <p>Your registration was successfull.</p>
      <br />
      <p>You will be redirected to your LMS shortly.</p>
    </div>
    <div class="form-container" v-else>
      <h4>Loading...</h4>
      <p>We are getting things ready for you.</p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "EmailLanding",
  data() {
    return {
      isLoading: true,
      error: false,
      errorMessage: "",
    };
  },
  mounted() {
    if (this.$route.query.token) {
      var userToken = this.$route.query.token;
      axios
        .get(`/api/users/login?token=${userToken}`)
        .then((response) => {
          this.isLoading = false;
          if (response.data.url) {
            location.replace(`https://${response.data.url}`);
          }
        })
        .catch(() => {
          this.error = true;
          this.errorMessage = `Please, contact support at
        <a href="mailto:support@elblearning.com" target="_blank"
          >support@elblearning.com</a
        >`;
        });
    } else {
      this.error = true;
      this.isLoading = false;
      this.errorMessage =
        "Token not found. Please, check your email and try again.";
    }
  },
};
</script>

<style></style>
